
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Emit, Prop} from 'vue-property-decorator';
  import {EditorToolbar, VueEditor} from 'vue2-editor';
  import {TopicEvents, TopicModel} from '@/models/topic.model';
  import {ChallengeForumApi} from '@/api/challenge-forum.api';
  import {validators} from '@/utils/validations';
  import {getToolbarConfig} from '@/utils/utils';
  import {take} from 'rxjs/operators';
  import {forumState} from '@/utils/store-acessor';
  import {Observable} from 'rxjs';

  @Component({
    components: {
      VueEditor
    }
  })
  export default class ChallengeForumTopicForm extends Vue {
    @Prop({required: true}) challengerId!: number;
    @Prop({required: false}) topicToUpdate?: TopicModel;
    customToolbar: EditorToolbar[] = getToolbarConfig();
    topic = new TopicModel();
    rules = validators;
    loading = false;

    snackbarVisibility: boolean = false;
    snackbarColor: string | null = null;
    snackbarText: string = '';

    mounted() {
      if (this.topicToUpdate) {
        this.topic = {...this.topicToUpdate}
      }
    }

    onSubmit() {
      let observable: Observable<TopicModel>;

      this.snackbarVisibility = false;

      if (!this.topic.topic || !this.topic.description) {
        return this.snackbarVisibility = true;
      }

      if (this.topic?.id) {
        this.loading = true;
        observable = new ChallengeForumApi(this.challengerId)
          .update(this.topic)
      } else {
        this.loading = true;
        observable = new ChallengeForumApi(this.challengerId)
          .create(this.topic)
      }

      observable.pipe(take(1))
        .subscribe((topic) => {
          this.loading = false;
          forumState.upsertTopic(topic);
          this.onForumBack()
        });
    }

    @Emit()
    onForumBack(): TopicEvents {
      return {showTable: true};
    }
  }
